import {
  Component,
  OnInit,
  OnDestroy,
  Inject,
  PLATFORM_ID,
} from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { Observable, of, combineLatest } from 'rxjs';
import { HeaderStatsService } from '../../../core/services/common/header-stats.service';
import { ClaimCounters } from '../../../core/models/claim-counters.models';
import { Subscription } from 'rxjs';
import { map } from 'rxjs/operators';

interface HeaderStats {
  counters: ClaimCounters;
  startDate: string;
}

/**
 * HeaderStatsComponent – shows a scrolling / marquee-style ticker with a single stat.
 * Fetches live counters from FactService and scrolls them horizontally.
 */
@Component({
  selector: 'app-header-stats',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div
      class="relative w-full select-none text-base pb-2 md:pt-2 text-gray-700 dark:text-gray-200 text-center"
    >
      <div *ngIf="stats$ | async as stats" class="font-normal">
        <span class="text-green-500 font-bold"
          >{{ stats.counters.true }} TRUE</span
        >,&nbsp;
        <span class="text-red-500 font-bold"
          >{{ stats.counters.false }} FALSE</span
        >,&nbsp;
        <span class="text-orange-500 font-bold"
          >{{ stats.counters.bullshit }} BS</span
        >
      </div>
      <div
        *ngIf="stats$ | async as stats"
        class="text-sm text-gray-600 dark:text-gray-300"
      >
        SINCE <b>{{ stats.startDate }}</b>
      </div>
    </div>
  `,
  styles: [],
})
export class HeaderStatsComponent implements OnInit, OnDestroy {
  stats$: Observable<HeaderStats>;
  private subscription: Subscription | null = null;

  constructor(
    private headerStatsService: HeaderStatsService,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {
    if (isPlatformBrowser(this.platformId)) {
      this.stats$ = combineLatest([
        this.headerStatsService.getFactCounters(),
        this.headerStatsService.getStartDate(),
      ]).pipe(
        map(([counters, startDate]) => ({
          counters,
          startDate: startDate || 'LAUNCH',
        })),
      );
    } else {
      this.stats$ = of({
        counters: { true: 0, false: 0, bullshit: 0 },
        startDate: '',
      });
    }
  }

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      this.subscription = this.stats$.subscribe();
    }
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
